/*
  Partspick — variant sync for the custom Device / Color dropdown.

  The custom "dropdown" block only updates select[name="id"], which does
  not exist on this theme (native variant picker is disabled). Result: the
  hidden input.product-variant-id kept the first variant, so a shopper who
  picked "iPhone 16" could get "iPhone 17 Pro Max" in the cart.

  This file keeps every variant-id field of the product form in sync with
  the options chosen in the custom dropdowns, and re-syncs right before
  the form is submitted.
*/
(function () {
  if (window.__ppVariantSync) return;
  window.__ppVariantSync = true;

  function norm(v) {
    return String(v || '').toLowerCase().replace(/\s+/g, '');
  }

  function getScope(el) {
    return el.closest('.shopify-section') || document;
  }

  function selectedValue(scope, type) {
    var opt = scope.querySelector(
      '.pp-custom-dropdown[data-dropdown="' + type + '"] .pp-dropdown-option[data-selected="true"]'
    );
    return opt ? opt.getAttribute('data-value') : null;
  }

  function readVariants(scope) {
    var el = scope.querySelector('script[data-pp-variants]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function sync(scope) {
    var variants = readVariants(scope);
    if (!variants || !variants.length) return;

    var device = selectedValue(scope, 'device');
    var color = selectedValue(scope, 'color');
    if (!device && !color) return;

    var match = null;
    for (var i = 0; i < variants.length; i++) {
      var opts = (variants[i].options || []).map(norm);
      if (device && opts.indexOf(norm(device)) === -1) continue;
      if (color && opts.indexOf(norm(color)) === -1) continue;
      match = variants[i];
      break;
    }
    if (!match) return;

    var fields = scope.querySelectorAll(
      'form[data-type="add-to-cart-form"] input[name="id"], input.product-variant-id, form[id^="product-form-installment"] input[name="id"]'
    );
    fields.forEach(function (field) {
      if (String(field.value) === String(match.id)) return;
      field.value = match.id;
      if (match.available) field.removeAttribute('disabled');
      field.dispatchEvent(new Event('change', { bubbles: true }));
    });

    var stickyPrice = document.querySelector('.pp-sticky [data-price]');
    if (stickyPrice && typeof match.price === 'number') {
      stickyPrice.textContent = 'Rs. ' + (match.price / 100).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    setSoldOut(scope, !match.available);

    try {
      var url = new URL(window.location.href);
      if (url.searchParams.get('variant') !== String(match.id)) {
        url.searchParams.set('variant', match.id);
        window.history.replaceState(window.history.state, '', url.toString());
      }
    } catch (e) {}
  }

  /* Sold-out model/colour: show "Sold out" on the Add to cart buttons
     instead of letting the shopper tap and get an error. */
  function setSoldOut(scope, soldOut) {
    var buttons = Array.prototype.slice.call(scope.querySelectorAll('.product-form__submit'));
    var sticky = document.querySelector('.pp-sticky [data-sticky-add]');
    if (sticky) buttons.push(sticky);
    var srBuy = scope.querySelector('.product-form__buttons .sr-headless-checkout');
    if (srBuy) srBuy.classList.toggle('pp-sr-soldout', soldOut);
    buttons.forEach(function (btn) {
      var label = btn.querySelector('span') || btn;
      if (btn.dataset.ppLabel == null) btn.dataset.ppLabel = label.textContent;
      if (soldOut) {
        btn.setAttribute('disabled', 'disabled');
        label.textContent = 'Sold out';
      } else if (btn.dataset.ppSoldOut === 'true') {
        btn.removeAttribute('disabled');
        label.textContent = btn.dataset.ppLabel;
      }
      btn.dataset.ppSoldOut = soldOut ? 'true' : 'false';
    });
  }

  function init() {
    var dropdowns = document.querySelectorAll('.pp-custom-dropdown');
    if (!dropdowns.length) return;

    var scopes = [];
    dropdowns.forEach(function (d) {
      var s = getScope(d);
      if (scopes.indexOf(s) === -1) scopes.push(s);
    });

    scopes.forEach(function (scope) {
      /* React to any selection change made by the dropdown block */
      new MutationObserver(function () {
        sync(scope);
      }).observe(scope, {
        attributes: true,
        attributeFilter: ['data-selected'],
        subtree: true
      });
      sync(scope);
    });

    /* Final safety net: re-sync in the capture phase, before the
       theme's product-form reads the form data. */
    document.addEventListener(
      'submit',
      function (e) {
        var form = e.target;
        if (!form || !form.matches || !form.matches('form[data-type="add-to-cart-form"]')) return;
        var scope = getScope(form);
        if (scopes.indexOf(scope) !== -1) sync(scope);
      },
      true
    );
    document.addEventListener(
      'click',
      function (e) {
        var btn = e.target.closest && e.target.closest('.product-form__submit, .shopify-payment-button__button, .sr-headless-checkout');
        if (!btn) return;
        var scope = getScope(btn);
        if (scopes.indexOf(scope) === -1) return;
        /* Shiprocket "Buy Now" on the product page: same rule as Add to
           cart - Model (and Color) must be picked first, otherwise the
           shopper would check out with the wrong variant. */
        if (btn.classList.contains('sr-headless-checkout') && !btn.closest('cart-drawer')) {
          if (typeof window.ppRequireSelection === 'function' && !window.ppRequireSelection()) {
            e.preventDefault();
            e.stopImmediatePropagation();
            return;
          }
        }
        sync(scope);
      },
      true
    );
  }

  /*
    "Buy Together & Save More" (pp-bundle) — the block's own script attached
    its submit listener to the first /cart/add form on the page, which is
    the hidden Shop Pay installments form, so ticked accessories were never
    added. Handle it here on the real add-to-cart form instead.
  */
  /* Model-specific accessories (e.g. lens protectors with 95 model/colour
     variants) are listed with ONE fixed variant (iPhone 17 Pro Max / Gray).
     Swap it for the variant that matches the iPhone model the shopper
     picked for the case, keeping the listed colour when possible. */
  function matchAccessory(variantId, device) {
    if (!device) return Promise.resolve(variantId);
    return fetch('/variants/' + variantId)
      .then(function (r) {
        var path = new URL(r.url).pathname.replace(/\/$/, '');
        return fetch(path + '.js', { headers: { Accept: 'application/json' } });
      })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        if (!p.variants || p.variants.length < 2) return variantId;
        var listed = p.variants.filter(function (v) { return String(v.id) === String(variantId); })[0];
        var target = norm(device);
        var candidates = p.variants.filter(function (v) {
          return v.available && v.options.some(function (o) { return norm(o) === target; });
        });
        if (!candidates.length) return variantId;
        if (listed) {
          var sameRest = candidates.filter(function (v) {
            return v.options.every(function (o, i) {
              return norm(o) === target || o === listed.options[i];
            });
          })[0];
          if (sameRest) return sameRest.id;
        }
        return candidates[0].id;
      })
      .catch(function () { return variantId; });
  }

  function initBundle() {
    var bundle = document.querySelector('.pp-bundle');
    if (!bundle) return;

    document.addEventListener(
      'submit',
      function (e) {
        var form = e.target;
        if (e.defaultPrevented) return;
        if (!form || !form.matches || !form.matches('form[data-type="add-to-cart-form"]')) return;

        var ticked = Array.prototype.slice
          .call(bundle.querySelectorAll('.pp-accessory-checkbox:checked'))
          .map(function (c) { return Number(c.value); })
          .filter(Boolean);
        if (!ticked.length) return;

        var scope = getScope(form);
        sync(scope);

        var fd = new FormData(form);
        var mainId = Number(fd.get('id'));
        if (!mainId) return;
        var qty = parseInt(fd.get('quantity'), 10);
        if (isNaN(qty) || qty < 1) qty = 1;

        e.preventDefault();
        e.stopImmediatePropagation();

        var button = form.querySelector('[type="submit"]');
        if (button) {
          button.setAttribute('aria-disabled', 'true');
          button.classList.add('loading');
        }

        var drawer = document.querySelector('cart-drawer');
        var device = selectedValue(scope, 'device');

        Promise.all(ticked.map(function (id) { return matchAccessory(id, device); }))
          .then(function (accessoryIds) {
            var body = {
              items: [{ id: mainId, quantity: qty }].concat(
                accessoryIds.map(function (id) { return { id: id, quantity: 1 }; })
              )
            };
            if (drawer && typeof drawer.getSectionsToRender === 'function') {
              body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
              body.sections_url = window.location.pathname;
            }
            return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify(body)
            });
          })
          .then(function (r) {
            return r.json().then(function (j) {
              if (!r.ok || j.status) throw new Error(j.description || 'add failed');
              return j;
            });
          })
          .then(function (j) {
            bundle.querySelectorAll('.pp-accessory-checkbox:checked').forEach(function (c) {
              c.checked = false;
              c.dispatchEvent(new Event('change', { bubbles: true }));
            });
            if (drawer && typeof drawer.renderContents === 'function' && j.sections) {
              drawer.renderContents(j);
            } else {
              window.location.href = '/cart';
            }
          })
          .catch(function () {
            /* fall back to adding just the case the normal way */
            form.submit();
          })
          .then(function () {
            if (button) {
              button.removeAttribute('aria-disabled');
              button.classList.remove('loading');
            }
          });
      },
      true
    );
  }

  initBundle();

  /* Sticky "Add to Cart" bar: only show it once the main Add to cart
     button has scrolled out of view (above the screen). */
  function initSticky() {
    var bar = document.querySelector('.pp-sticky');
    var main = document.querySelector('form[data-type="add-to-cart-form"] .product-form__submit');
    if (!bar) return;
    if (!main) {
      bar.classList.add('pp-sticky--show');
      return;
    }
    var ticking = false;
    function update() {
      ticking = false;
      var r = main.getBoundingClientRect();
      bar.classList.toggle('pp-sticky--show', r.bottom < 0);
    }
    window.addEventListener('scroll', function () {
      if (!ticking) {
        ticking = true;
        setTimeout(update, 40);
      }
    }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSticky);
  } else {
    initSticky();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
})();